import { useState, useEffect } from "react";
import { Box, Grid } from "@mui/material";
import { useLocation } from "react-router-dom";
import CustomText from "../components/CustomText";
import FormDoctorsDirectory from "../components/FormDoctorsDirectory";
import CarouselCard from "../components/CarouselCard";
import CarouselDoctors from "../components/CarouselDoctors";
import Footer from "../components/Footer";
import InsuranceCompanies from "../components/InsuranceCompanies";
import Header from "../01-Services/Header";
import ServiceItem from "../01-Services/ServiceItem";
import AwardsCertifications from "../01-Services/AwardsCertifications";
import TypeHospitalization from "../01-Services/TypeHospitalization";
import CarruselHopitalization from "../01-Services/CarruselHopitalization";
import PhotosHospitalization from "../01-Services/PhotosHospitalization";
import CustomDescrip from "../01-Services/CustomDescrip";
import { getAvailablePromotionsHomeWeb } from "../services/promotionsService";
import { Helmet } from "react-helmet-async";

const Services = () => {
  const [pending, setPending] = useState(null);
  const [visible, setVisible] = useState(true);
  const [specialPackages, setSpecialPackages] = useState([]);
  const [loadingPackages, setLoadingPackages] = useState(false);
  const [searchResultsDoctors, setSearchResultsDoctors] = useState([]);

  const handleDoctorSearch = (result) => {
    if (Array.isArray(result)) {
      setSearchResultsDoctors(result);
    } else if (result) {
      setSearchResultsDoctors([result]);
    } else {
      setSearchResultsDoctors([]);
    }
  };

  const useQuery = () => new URLSearchParams(useLocation().search);
  const query = useQuery();
  const name = query.get("name");

  const [selected, setSelected] = useState(
    fulter.find((f) => f.name === name) || fulter[0],
  );

  const handleClick = (item) => {
    if (item.name === selected.name) return;

    setVisible(false);
    setPending(item);
  };

  useEffect(() => {
    if (!visible && pending) {
      const timeout = setTimeout(() => {
        setSelected(pending);
        setVisible(true);
        setPending(null);
      }, 150);

      return () => clearTimeout(timeout);
    }
  }, [visible, pending]);

  useEffect(() => {
    let isMounted = true;

    const loadPromotions = async () => {
      setLoadingPackages(true);
      const promotions = await getAvailablePromotionsHomeWeb();

      if (isMounted) {
        setSpecialPackages(promotions);
        setLoadingPackages(false);
      }
    };

    loadPromotions();

    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <>
      <Helmet>
        <title>Servicios Médicos | Centro Médico MEDAM</title>
        <meta
          name="description"
          content="Conoce los servicios médicos de Centro Médico MEDAM: torre médica, hospitalización, urgencias 24 horas, laboratorio clínico, farmacia y atención especializada."
        />
        <meta
          name="keywords"
          content="Centro Médico MEDAM, servicios médicos, hospitalización, urgencias 24 horas, laboratorio clínico, farmacia, médicos especialistas, hospital en México"
        />
        {/* Open Graph para WhatsApp, Facebook, etc */}
        <meta
          property="og:title"
          content="Servicios Médicos | Centro Médico MEDAM"
        />
        <meta
          property="og:description"
          content="Atención médica integral con especialistas, urgencias 24 horas, hospitalización, laboratorio y servicios de salud."
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content="https://centromedicomedam.com/services"
        />
        <meta
          property="og:image"
          content="https://centromedicomedam.com/IMG/centromedicoMEDAM/backgroundImage_Torre_Medica_del_centro-medico_MEDAM.png"
        />
        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Servicios Médicos | Centro Médico MEDAM"
        />
        <meta
          name="twitter:description"
          content="Conoce nuestros servicios médicos especializados."
        />
        <meta
          name="twitter:image"
          content="https://centromedicomedam.com/IMG/centromedicoMEDAM/backgroundImage_Torre_Medica_del_centro-medico_MEDAM.png"
        />
        {/* SEO técnico */}
        <link rel="canonical" href="https://centromedicomedam.com/services" />
      </Helmet>
      <Grid
        container
        sx={{
          backgroundImage: `url(${selected?.image})`,
          ...design.Back,
        }}
      >
        <Header
          fulter={fulter}
          selected={selected}
          handleClick={handleClick}
          visible={visible}
        />
      </Grid>
      <Box sx={design.Box}>
        {selected.name === "Torre medica" ? (
          <>
            <FormDoctorsDirectory />
            {services.map((service, index) => (
              <ServiceItem
                key={service.id ?? service.title ?? index}
                idx={index}
                title={service.title}
                description={service.description}
                image={service.image}
                reverse={index % 2 !== 0}
                color={service.color}
              />
            ))}
          </>
        ) : selected.name === "Hospitalización" ? (
          <>
            <FormDoctorsDirectory />
            <TypeHospitalization TypeHospi={TypeHospi} />
            <CarruselHopitalization />
            <PhotosHospitalization />
          </>
        ) : selected.name === "Urgencias" ? (
          DescripUrgencias.map((item, index) => (
            <CustomDescrip key={index} {...item} reverse={index % 2 !== 0} />
          ))
        ) : selected.name === "Laboratorio Clínico" ? (
          <>
            {DescripLaboratorio.map((item, index) => (
              <CustomDescrip key={index} {...item} reverse={index % 2 !== 0} />
            ))}
            <CustomText variant="subtitle1" color="#000" sx={design.Title}>
              Paquetes especiales
            </CustomText>
            <CarouselCard
              cards={specialPackages}
              colorIcon="#000"
              loadingPackages={loadingPackages}
            />
          </>
        ) : selected.name === "Farmacia" ? (
          DescripFarmacia.map((item, index) => (
            <CustomDescrip key={index} {...item} reverse={index % 2 !== 0} />
          ))
        ) : null}

        <AwardsCertifications />
        <FormDoctorsDirectory
          onSearch={handleDoctorSearch}
          showDropdown={false}
          enableSearch={true}
        />

        <CarouselDoctors colorIcon="#000" cards={searchResultsDoctors} />
        <InsuranceCompanies />
        <Footer />
      </Box>
    </>
  );
};

export default Services;
const design = {
  Back: {
    backgroundPosition: "center",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    display: "flex",
    justifyContent: "center",
  },
  Box: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  Title: {
    fontFamily: "Plus Jakarta Sans",
    fontSize: {
      xs: 25,
      sm: 25,
      md: 35,
      lg: 35,
    },
    fontWeight: 600,
    lineHeight: "normal",
    marginTop: "2%",
    textAlign: "center",
    width: "100%",
  },
  ButtonBase: {
    padding: "10px 20px",
    borderRadius: "10px",
    fontWeight: 600,
    transition: "0.3s",
    fontSize: 18,
    marginLeft: 1,
    marginRight: 1,
    marginTop: 5,
    marginBottom: 5,
    color: "#fff",
  },
  Description: {
    fontFamily: "Plus Jakarta Sans",
    fontSize: {
      xs: 18,
      sm: 18,
      md: 20,
      lg: 20,
    },
    lineHeight: "normal",
    textAlign: "left",
  },
};
const fulter = [
  {
    name: "Torre medica",
    color: "#2349D0",
    logo: "https://centromedicomedam.com/IMG/centromedicoMEDAM/Logo_Centro_Medico_Medam_Torre_medica.png",
    image:
      "https://centromedicomedam.com/IMG/centromedicoMEDAM/backgroundImage_Torre_Medica_del_centro-medico_MEDAM.png",
  },
  {
    name: "Hospitalización",
    color: "#9027E2",
    logo: "https://centromedicomedam.com/IMG/centromedicoMEDAM/Logo_Centro_Medico_Medam_Laboratorio_Clinico.png",
    image:
      "https://centromedicomedam.com/IMG/centromedicoMEDAM/backgroundImage_Hospitalizacion_del_centro-medico_MEDAM.png",
  },
  {
    name: "Urgencias",
    color: "#8A1313",
    logo: "https://centromedicomedam.com/IMG/centromedicoMEDAM/Logo_Centro_Medico_Medam_Urgencias.png",
    image:
      "https://centromedicomedam.com/IMG/centromedicoMEDAM/backgroundImage_Urgencias_del_centro-medico_MEDAM.png",
  },
  {
    name: "Laboratorio Clínico",
    color: "#56AB91",
    logo: "https://centromedicomedam.com/IMG/centromedicoMEDAM/Logo_Centro_Medico_Medam_Laboratorio_Clinico.png",
    image:
      "https://centromedicomedam.com/IMG/centromedicoMEDAM/backgroundImage_Laboratorio_Clinico_del_centro-medico_MEDAM.png",
  },
  {
    name: "Farmacia",
    color: "#2349D0",
    logo: "https://centromedicomedam.com/IMG/centromedicoMEDAM/Logo_Centro_Medico_Medam_Laboratorio_Clinico.png",
    image:
      "https://centromedicomedam.com/IMG/centromedicoMEDAM/backgroundImage_Farmacia_del_centro-medico_MEDAM.png",
  },
];

const services = [
  {
    title: "Medicina General",
    description:
      "En MEDAM, la medicina general es el primer paso para cuidar tu salud. Nuestros médicos están capacitados para atender padecimientos comunes, dar orientación preventiva y guiarte hacia el tratamiento adecuado. Estamos aquí para escucharte, resolver tus dudas y acompañarte en cada etapa.",
    image:
      "https://centromedicomedam.com/IMG/centromedicoMEDAM/medicina_general_detalles_del_centro-medico_MEDAM.jpg",
    color: "#2349D0",
  },
  {
    title: "Pediatría",
    description:
      "El bienestar de tus hijos es nuestra prioridad. Nuestros pediatras brindan atención especializada desde el nacimiento hasta la adolescencia, con calidez, experiencia y enfoque integral. Cuidamos la salud de los más pequeños como si fueran parte de nuestra familia.",
    image:
      "https://centromedicomedam.com/IMG/centromedicoMEDAM/Pediatria_del_centro-medico_MEDAM.jpg",
    color: "#6682E6",
  },
  {
    title: "Ginecología",
    description:
      "Acompañamos a la mujer en cada etapa de su vida. Nuestro equipo de ginecología brinda atención integral en salud femenina: desde chequeos preventivos hasta tratamientos especializados, siempre con empatía, respeto y profesionalismo.",
    image:
      "https://centromedicomedam.com/IMG/centromedicoMEDAM/Ginecologia_del_centro-medico_MEDAM.jpg",
    color: "#AC5CD4",
  },
  {
    title: "Ortopedia",
    description:
      "Diagnosticamos y tratamos lesiones, fracturas y afecciones del sistema músculo-esquelético con precisión y cuidado. En MEDAM, nuestros especialistas en ortopedia te ofrecen soluciones efectivas para recuperar tu bienestar físico.",
    image:
      "https://centromedicomedam.com/IMG/centromedicoMEDAM/Ortopedia_del_centro-medico_MEDAM.jpg",
    color: "#162E84",
  },
  {
    title: "Neurología",
    description:
      "Entendemos la importancia de un sistema nervioso sano para tu calidad de vida. Nuestros especialistas en neurología te ofrecen una atención integral, precisa y cercana, enfocada en cuidar tu salud cerebral y neurológica con profesionalismo y empatía",
    image:
      "https://centromedicomedam.com/IMG/centromedicoMEDAM/Neurologia_del_centro-medico_MEDAM.jpg",
    color: "#5291DD",
  },
  {
    title: "Medicina Interna",
    description:
      "En MEDAM, nuestros médicos internistas te ofrecen una visión integral de tu salud. Evaluamos de forma completa tu estado general para detectar, prevenir y tratar diversas condiciones, siempre con atención cercana, profesional y personalizada.",
    image:
      "https://centromedicomedam.com/IMG/centromedicoMEDAM/Medicina_interna_detalles_del_centro-medico_MEDAM.jpg",
    color: "#489E4D",
  },
  {
    title: "Cardiología",
    description:
      "El corazón no solo late, también siente. Por eso, en MEDAM te ofrecemos una atención cardiológica integral, con tecnología, experiencia y el trato cálido que necesitas para cuidar lo más vital. ",
    image:
      "https://centromedicomedam.com/IMG/centromedicoMEDAM/Cardiologia_del_centro-medico_MEDAM.jpg",
    color: "#6682E6",
  },
];

const TypeHospi = [
  {
    Title: "Cirugía General",
    description:
      "Nuestro servicio de cirugía general hospitalaria en MEDAM está respaldado por quirófanos equipados con tecnología de última generación y un equipo médico altamente capacitado. Desde el preoperatorio hasta tu recuperación, cuidamos cada detalle para ofrecerte procedimientos seguros, eficaces y con un trato humano que genera confianza.",
    color: "#13345E",
  },
  {
    Title: "Gineco-Obstetricia",
    description:
      "Las pacientes ginecológicas y obstétricas cuentan con un piso exclusivo diseñado para brindar privacidad, confort y atención especializada. Nuestro equipo médico y de enfermería está enfocado en acompañarte con calidez en cada etapa del tratamiento o recuperación, en un entorno pensado especialmente para ti.",
    color: "#2349D0",
  },
  {
    Title: "Pediatría",
    description:
      "Los más pequeños reciben atención médica en espacios adaptados especialmente para ellos. Contamos con habitaciones pediátricas diseñadas para ofrecer un entorno cómodo y seguro, así como un equipo de especialistas que brinda cuidados hospitalarios con empatía, experiencia y cercanía hacia las familias.",
    color: "#AC5CD4",
  },
  {
    Title: "Traumatología",
    description:
      "En casos que requieren hospitalización por lesiones, fracturas o cirugías ortopédicas, nuestro equipo de traumatología te acompaña con un enfoque profesional y resolutivo. En MEDAM contamos con infraestructura especializada para tu recuperación y atención médica continua centrada en devolverte tu movilidad y bienestar.",
    color: "#6682E6",
  },
  {
    Title: "Urología",
    description:
      "El servicio de urología hospitalaria ofrece procedimientos quirúrgicos y tratamientos que requieren internamiento en un entorno seguro y moderno. Nuestros especialistas cuidan de tu salud urológica con profesionalismo, discreción y la infraestructura necesaria para garantizar tu tranquilidad.",
    color: "#FB3748",
  },
  {
    Title: "Neurología",
    description:
      "Brindamos atención neurológica especializada dentro del entorno hospitalario para pacientes que requieren estudios, monitoreo o tratamientos complejos. Contamos con infraestructura de apoyo diagnóstico y un equipo médico capacitado para acompañarte en cada etapa, con precisión clínica y un trato humano que prioriza tu bienestar.",
    color: "#BF6A02",
  },
  {
    Title: "Cardiología",
    description:
      "Nuestra unidad de cardiología hospitalaria está preparada para atender desde valoraciones especializadas hasta eventos que requieren cuidados inmediatos. Combinamos monitoreo avanzado, tecnología de punta y un equipo de cardiólogos que trabaja contigo para estabilizar, tratar y proteger tu salud cardiovascular con excelencia y empatía.",
    color: "#489E4D",
  },
];

const DescripUrgencias = [
  {
    title: null,
    description: (
      <CustomText
        variant="subtitle1"
        color="#333333"
        text="En MEDAM"
        sx={design.Description}
      >
        En MEDAM, estamos listos para actuar cuando más se necesita.
        <br />
        <br />
        Nuestra <strong>área de urgencias</strong> opera las{" "}
        <strong>24 horas del día, los 365 días del año</strong>, con un equipo
        de <strong>médicos urgenciólogos y personal capacitado </strong>
        preparado para atender cualquier tipo de emergencia con rapidez,
        seguridad y precisión.
        <br />
        <br />
        Contamos con un <strong>cuarto de choque totalmente equipado</strong>,
        acceso inmediato a pruebas diagnósticas y un diseño que permite{" "}
        <strong>entrada directa desde el estacionamiento</strong> para una
        atención más ágil y eficiente.
        <br />
        <br />
        Porque tu vida y tu tranquilidad no pueden esperar.
      </CustomText>
    ),
    question: "Dudas o preguntas",
    img: "https://centromedicomedam.com/IMG/centromedicoMEDAM/Urgencias_del_centro-medico_MEDAM.jpg",
  },
];

const DescripLaboratorio = [
  {
    title: "Laboratorio Clínico Duran",
    description: (
      <CustomText
        variant="subtitle1"
        color="#333333"
        text="En MEDAM"
        sx={design.Description}
      >
        Nos aliamos con uno de los laboratorios más prestigiosos del país para
        garantizar diagnósticos confiables en todo momento.
        <br />
        En MEDAM, contarás con{" "}
        <strong>laboratorio clínico disponible las 24 horas</strong>, así como
        servicios de{" "}
        <strong>
          Rayos X, Tomografía, Ultrasonido, Mastografía, Resonancia Magnética
        </strong>{" "}
        y estudios especiales.
        <br />
        Esta alianza asegura una atención médica respaldada por{" "}
        <strong>
          tecnología de vanguardia y un equipo altamente capacitado
        </strong>
        , para cuidar de tu salud con precisión, rapidez y seguridad.
      </CustomText>
    ),
    question: "Ver más infromación",
    questionto: "https://dulab.com.mx/",
    img: "https://centromedicomedam.com/IMG/centromedicoMEDAM/Tomografia_del_centro-medico_MEDAM.png",
  },
  {
    title: "MoviCare",
    description: (
      <CustomText
        variant="subtitle1"
        color="#333333"
        text="En MEDAM"
        sx={design.Description}
      >
        Nuestra alianza con MoviCare extiende la atención médica hasta la puerta
        de tu casa. A través de este servicio, ofrecemos:
        <br />
        <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&bull;&nbsp;Estudios de laboratorio clínico a
        domicilio
        <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&bull;&nbsp;Rayos X en casa
        <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&bull;&nbsp;Traslados en ambulancia
        <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&bull;&nbsp;Atención para pacientes con
        movilidad reducida
        <br />
        <br />
        Todo bajo una misma visión: facilitar una atención médica integral,
        digna y accesible, estés donde estés.
      </CustomText>
    ),
    question: "Ver más infromación",
    questionto: "https://movicaremx.com/",
    img: "https://centromedicomedam.com/IMG/centromedicoMEDAM/MoviCare_del_centro-medico_MEDAM.png",
  },
];

const DescripFarmacia = [
  {
    title: null,
    description: (
      <CustomText
        variant="subtitle1"
        color="#333333"
        text="En MEDAM"
        sx={design.Description}
      >
        En la farmacia de MEDAM, tu salud es nuestra prioridad.
        <br />
        Contamos con un <strong>amplio surtido de medicamentos</strong>, insumos
        y productos esenciales, seleccionados para acompañarte en cada etapa de
        tu tratamiento.
        <br />
        <br />
        Gracias a un equipo <strong>capacitado</strong> y procesos eficientes,
        te garantizamos un servicio ágil, confiable y siempre cercano.
        <br />
        Además, nuestras farmacias están integradas al modelo de atención médica
        de MEDAM, lo que permite una mayor coordinación con los especialistas
        que te atienden.
        <br />
        <br />
        Aquí encontrarás{" "}
        <strong>todo lo que necesitas para cuidar de ti y de los tuyos</strong>,
        con la confianza de estar en buenas manos.
      </CustomText>
    ),
    // question: "Dudas o preguntas",
    img: "https://centromedicomedam.com/IMG/centromedicoMEDAM/Farmacia_detalles_del_centro-medico_MEDAM.png",
  },
];
